// Import the Plus icon from `lucide-react` and the `ResponsibleData` type
import { Plus } from 'lucide-react';
import type { ResponsibleData } from '../../types/auth';

// Define the props for the DashboardHeader component
interface DashboardHeaderProps {
  user: ResponsibleData | null; // The authenticated user, or null if not logged in
  onCreateJob: () => void; // Callback function for creating a new job
}

/**
 * The DashboardHeader component displays a heading, a welcome message for the user, and a button to create a new job posting.
 */
export function DashboardHeader({ user, onCreateJob }: DashboardHeaderProps) {
  return (
    <div className="md:flex md:items-center md:justify-between mb-6">
      {/* Left Section: Heading and Welcome Message */}
      <div className="min-w-0 flex-1">
        <h1 className="text-2xl font-bold leading-7 text-primary-dark sm:truncate sm:text-3xl">
          Tableau de bord
        </h1>
        <p className="mt-1 text-sm text-text-secondary">
          Bienvenue {user?.full_name} {/* Display the user's full name if available */}
        </p>
      </div>

      {/* Right Section: Create Job Button */}
      <div className="mt-4 flex md:ml-4 md:mt-0">
        <button
          type="button"
          onClick={onCreateJob} // Trigger the `onCreateJob` callback when clicked
          className="ml-3 inline-flex items-center rounded-md bg-primary-main px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-dark"
        >
          <Plus className="h-5 w-5 mr-2" /> {/* Icon indicating adding a new item */}
          Nouvelle offre {/* Button label */}
        </button>
      </div>
    </div>
  );
}
